const tenant_name = '';

export const apiUrl = `https://riskvision-api.mygate.ai/api`;
// export const apiUrl = `http://localhost:5001/api`;
export const defaultPagination = 20;
export const perPageList =  [20, 50, 100];
export const is_live = false;

export const APP_NAME = '';
export const APP_PORTAL = 'staff';
export const APP_TENANT = tenant_name;
export const APP_LEVEL_2_URL = ""
export const APP_DEMO_TENANT_AUTH_PAGE = ""
export const APP_CHANNEL_PARTNER_PORTAL = ""

export const baseUri = window.location.host
export const GoCardLessRedirectUri = ''
export const GoCardLessExitUri = ''

export const MASTER_TENANT_DOMAIN = ''
